import React, { Fragment } from 'react'
import DeleteBtn from '../../buttons/DeleteBtn'
import EditBtn from '../../buttons/EditBtn'
import NullMssg from '../../common/NullMssg'
import { mssgs } from '../../../constantes/mssgs'
import _ from 'lodash'

const SpecialtiesList = (
    { 
        allSpecialties,
        handleRemove,
        openEditModal
    }
) => {

    allSpecialties = _.orderBy(allSpecialties, ['nombre'],['asc'])
    
    return (
        <Fragment>
            <table>
                <thead>
                    <tr>
                        <th>
                            Nombre
                        </th>
                        <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                            Acciones
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allSpecialties.length > 0 ? allSpecialties.map((speciality, i) =>
                            <tr key={i}>
                                <td>
                                    <p className="products__text">{speciality.nombre}</p>
                                </td>
                                <td className="table-td-actions">
                                    <button onClick={() => openEditModal(speciality)}><EditBtn /></button>
                                    <button onClick={() => handleRemove(speciality.id_TipoEspecialidad)}><DeleteBtn /></button>
                                </td>
                            </tr>
                        ) : <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_ESPECIALIDADES_MEDICAS}/>
                    }
                </tbody>
            </table>
        </Fragment>
    )
}

export default SpecialtiesList